/* oxlint-disable no-console */
import { anvilDebugStorageKey } from "@wombat/anvil/core";
import { eventsBrowserApi } from "./events-browser-api";
import { performanceTracker } from "../utilities/performance";

/**
 * API for turning on and off log levels within the browser
 *
 * Integrations:
 * - logging module
 * - Anvil diagnostics
 * - Performance measurements
 */

(function () {
  if (typeof window === "undefined") {
    return;
  }

  const wombat = window.__wombat || {};
  const logging = wombat.logging || {};

  if (!logging.queryBridge) {
    logging.queryBridge = {
      level: localStorage.getItem("__wombat.queryBridge.level") || "warn",
      /**
       * @param {"warn" | "debug" | "log"} key
       */
      enable(key) {
        if (!["warn", "log", "debug"].includes(key)) {
          console.warn("Log level must be on of ", ["warn", "log", "debug"]);
          return;
        }
        this.level = key;
        localStorage.setItem("__wombat.queryBridge.level", key);
        console.log("Query Bridge: logging level set to '", key);
      },
    };
  }

  if (!logging.anvil) {
    logging.anvil = {
      enabled: localStorage.getItem(anvilDebugStorageKey) === "true",
      enable() {
        this.enabled = true;
        localStorage.setItem(anvilDebugStorageKey, "true");
        console.log("Anvil: debug logging enabled");
      },
      disable() {
        this.enabled = false;
        localStorage.setItem(anvilDebugStorageKey, "false");
        console.log("Anvil: debug logging disabled");
      },
    };
  }

  wombat.logging = logging;
  wombat.events = eventsBrowserApi;
  wombat.performance = performanceTracker;
  window.__wombat = wombat;
})();
